import { render, staticRenderFns } from "./ChartstoperrBar.vue?vue&type=template&id=db145792&"
import script from "./ChartstoperrBar.vue?vue&type=script&lang=js&"
export * from "./ChartstoperrBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports